import { BookmarkAssetUtil } from "./assets/BookmarkAssetUtil.mjs";
import { ImageAssetUtil } from "./assets/ImageAssetUtil.mjs";
import { VideoAssetUtil } from "./assets/VideoAssetUtil.mjs";
const defaultAssetUtils = [ImageAssetUtil, VideoAssetUtil, BookmarkAssetUtil];
export {
  defaultAssetUtils
};
//# sourceMappingURL=defaultAssetUtils.mjs.map
